export default __webpack_public_path__ + "static/media/broc-caleb-01-1.226d84eb.PNG";